import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Hero from './Hero';
import Principles from './Principles';
import JourneySplit from './JourneySplit';
import PlatformSurfaces from './PlatformSurfaces';
import CultureSplit from './CultureSplit';
import JourneyTimeline from './JourneyTimeline';
import FeatureAtlas from './FeatureAtlas';
import AISuite from './AISuite';
import WhyZuntly from './WhyZuntly';
import Pricing from './Pricing';
import ContactLead from './ContactLead';
import Footer from './Footer';
import ScrollToTopButton from './ScrollToTopButton';
import LeadModal from './LeadModal';

export default function Home({ showPopup, setShowPopup }) {
  return (
    <main className="app-shell">
      <ToastContainer position="bottom-right" theme="dark" />
      <Hero onGetStarted={() => setShowPopup(true)} />
      <Principles />
      <JourneySplit />
      <PlatformSurfaces />
      <CultureSplit />
      <JourneyTimeline />
      <FeatureAtlas />
      <AISuite />
      <WhyZuntly />
      <Pricing onGetStarted={() => setShowPopup(true)} />
      <ContactLead />
      <Footer />
      <ScrollToTopButton />
      <LeadModal open={showPopup} onClose={() => setShowPopup(false)} />
    </main>
  );
}
